import { deviceSystemAgeOptions } from "constants/DeviceSystemAgeOptions"
import {
  contractorMonitoringPerformanceTestStatusOptions,
  deviceAccessoriesOptions,
  devicesAlertsOptions,
  devicesMembershipOptions,
  deviceSystemTypeOptions,
  deviceWorkStatusOptions,
  hvacOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { CustomerMembershipType } from "components/table/columnComponents/CustomerMembershipType"
import { CustomerName } from "components/table/columnComponents/CustomerName"
import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { StatusOfWork } from "components/table/columnComponents/StatusOfWork"

export const monitoringTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
    cellComponent: CustomerEmail,
  },
  {
    title: "Status",
    type: "select",
    name: "perftest_status",
    size: "small",
    options: contractorMonitoringPerformanceTestStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Work status",
    type: "select",
    name: "work_status",
    size: "small",
    options: deviceWorkStatusOptions,
    cellComponent: StatusOfWork,
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "small",
  },
  {
    title: "ZIP code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
    cellComponent: CustomerName,
  },
  {
    title: "S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Thermostat name",
    type: "sort-search",
    size: "middle",
    name: "name",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
  },
  {
    title: "Installation type",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
  {
    title: "Alerts",
    type: "select",
    size: "small",
    name: "alerts",
    options: devicesAlertsOptions,
  },
  {
    title: "Membership",
    type: "select",
    name: "membership",
    options: devicesMembershipOptions,
    size: "small",
  },
  {
    title: "Membership type",
    type: "search",
    name: "membership_name",
    size: "middle",
    cellComponent: CustomerMembershipType,
  },
  {
    title: "System type",
    type: "select",
    size: "small",
    name: "system_type",
    options: deviceSystemTypeOptions,
  },
  {
    title: "System age",
    type: "select",
    size: "middle",
    name: "system_age",
    options: deviceSystemAgeOptions,
  },
  {
    title: "Accessories",
    type: "select",
    size: "small",
    name: "accessories",
    options: deviceAccessoriesOptions,
  },
]
